import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import RequiredIcon from '../../../assets/icons/required-checkbox.svg';
import { FileContext } from '../../../context/FileContext';
import { useColumnOrder } from '../../../hooks/useColumnOrder';
import CustomCheckboxSVG from './CheckboxSVG';
import CustomCheckboxUncheckedSVG from './CheckboxUncheckedSVG';

const CheckboxPreviewContainer = styled.div`
  top: ${({ y }) => y + 'px'};
  left: ${({ x }) => x + 'px'};
  width: ${({ width }) => width + 'px'};
  height: ${({ height }) => height + 'px'};
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: center;
  cursor: pointer;
  pointer-events: auto;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
`;

const CheckboxPreviewOverlayChip = ({ x, y, item, from, showColor }) => {
  const { addedFormFields, updateFormFields } = useContext(FileContext);
  const { mapColor } = useColumnOrder();

  const [defaultIcon, setDefaultIcon] = useState('unchecked');
  const [isChecked, setIsChecked] = useState(false);

  const itemColor = item.color ?? item.signer?.color;
  const backgroundColor = itemColor
    ? mapColor(itemColor)
    : '#E6E6FA';

  const handleClick = () => {
    setIsChecked((s) => !s);
    if (isChecked) {
      setDefaultIcon('unchecked');
    } else {
      setDefaultIcon('checked');
    }
    if (from !== '/sign') return;
    const selectedItem = addedFormFields.find((x) => x.id === item.id);
    if (!selectedItem) return;
    selectedItem.isChecked = !selectedItem.isChecked;
    selectedItem.hasError = false;
    updateFormFields([...addedFormFields]);
  };

  useEffect(() => {
    if (item.hasError) {
      setDefaultIcon(RequiredIcon);
    }
  }, [addedFormFields]);

  return (
    <CheckboxPreviewContainer
      x={x}
      y={y}
      height={item.height}
      width={item.width}
      onClick={handleClick}
    >
      {defaultIcon === 'checked' ? (
        <CustomCheckboxSVG
          fill={showColor && item.color ? backgroundColor : 'black'}
        />
      ) : (
        <CustomCheckboxUncheckedSVG
          fill={
            showColor && item.color
              ? mapColor(item.color)
              : item.hasError
              ? 'red'
              : 'black'
          }
        />
      )}
    </CheckboxPreviewContainer>
  );
};

export default CheckboxPreviewOverlayChip;
